import { ROUTES } from "./constants";

type RouteWithParams =
  | "leaseApplication"
  | "leaseDetails"
  | "amenityDetails"
  | "amenityReservation"
  | "unitDetails"
  | "unitPlanDetails"
  | "buildingDetails"
  | "serviceRequestDetails"
  | "messageDetails"
  | "propertyDetails";

/**
 * Replaces route parameters with actual IDs
 * @param routeKey - The key from ROUTES object that contains parameters
 * @param params - Object containing the parameter values to replace
 * @returns The route with parameters replaced
 * @example
 * // For routes with one parameter
 * getRouteWithParams("leaseDetails", { leaseID: "123" })
 * // Returns: "/lease/123"
 *
 * // For routes with two parameters
 * getRouteWithParams("leaseApplication", { entityType: "tenant", entityID: "456" })
 * // Returns: "/lease-application/tenant/456"
 */
export const getRouteWithParams = (
  routeKey: RouteWithParams,
  params: Record<string, string>
): string => {
  let route = ROUTES[routeKey];

  // Replace each parameter in the route
  Object.entries(params).forEach(([key, value]) => {
    route = route.replace(`:${key}`, value);
  });

  return route;
};
